import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useUserList } from "@/hooks/useUserList";
import { Role, User } from "@/models/user";
import { UserService } from "@/services/users/users.service";

export const useUser = (userId?: string) => {
  const navigate = useNavigate();
  const { users, isLoading: isLoadingUserList, mutate } = useUserList();
  const [user, setUser] = useState<User | undefined>(undefined);
  const [isLoading, setIsLoading] = useState(isLoadingUserList);

  useEffect(() => {
    const targetUser = users?.find((user) => user.id === userId);
    if (!isLoadingUserList && !targetUser) {
      navigate("/404", { replace: true });
      return;
    }

    setUser(targetUser);
    setIsLoading(false);
  }, [userId, isLoadingUserList]);

  const updateUser = async (userId: string, name: string, role: Role) => {
    setIsLoading(true);
    await UserService.updateUser(userId, name, role);
    await mutate();
    setIsLoading(false);
  };

  return { user, isLoading, updateUser };
};
